import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.scss";
import { loginUser } from "../../api/apiServiceFetch";

const EyeIcon = ({ visible }) =>
	visible ? (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path
				d="M3 3l18 18M10.58 10.58a2 2 0 002.83 2.83M9.88 5.09A10.94 10.94 0 0112 5c5 0 9.27 3.11 11 7-.53 1.18-1.3 2.26-2.27 3.18M6.61 6.61C4.74 7.96 3.27 9.85 2.5 12c1.73 3.89 6 7 11 7 1.62 0 3.16-.33 4.55-.92"
				stroke="currentColor"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	) : (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path
				d="M2.5 12C4.23 8.11 8.5 5 13 5s8.77 3.11 10.5 7c-1.73 3.89-6 7-10.5 7S4.23 15.89 2.5 12z"
				stroke="currentColor"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="13"
				cy="12"
				r="3"
				stroke="currentColor"
				strokeWidth="1.6"
			/>
		</svg>
	);

const Login = () => {
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		username: "",
		password: "",
		captcha: "",
	});
	const [isUsernameEmpty, setIsUsernameEmpty] = useState(false);
	const [isPasswordEmpty, setIsPasswordEmpty] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	// const [captcha, setCaptcha] = useState(generateCaptcha());
	const [errorMessage, setErrorMessage] = useState("");

	// const handleChangeLanguage = (e) => {
	//     changeLanguage(e.value);
	// };

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});
	};

	// const handleNumericInputChange = (e) => {
	//     const { name, value } = e.target;
	//     const numericValue = value.replace(/\D/g, ''); // Remove non-numeric characters
	//     setFormData({
	//         ...formData,
	//         [name]: numericValue
	//     });
	// };

	const handleSubmit = async (e) => {
		e.preventDefault();

		// Check if the fields are empty
		const isUsernameEmptyCheck = formData.username.trim() === "";
		const isPasswordEmptyCheck = formData.password.trim() === "";

		setIsUsernameEmpty(isUsernameEmptyCheck);
		setIsPasswordEmpty(isPasswordEmptyCheck);

		if (!isUsernameEmptyCheck && !isPasswordEmptyCheck) {
			// if (parseInt(formData.captcha, 10) === captcha.answer) {

			// setIsCaptchaIncorrect(false);
			try {
				const loginResponse = await loginUser(formData);
				if (loginResponse.isSuccess) {
					navigate("/");
				} else {
					// setCaptcha(generateCaptcha());
					setErrorMessage("Неверные данные входа");
				}
			} catch (error) {
				setErrorMessage("Ошибка сервера");
			}
			// } else {
			//     // setIsCaptchaIncorrect(true);
			//     //setCaptcha(generateCaptcha());
			//     setFormData({
			//         ...formData,
			//         captcha: ''
			//     });
			// }
		}
	};

	return (
		<div className="container">
			<div className="login-container">
				<div className="login_header">
					{/* <DropDown data={languageOptions} placeholder="Select language" value={language} onChange={handleChangeLanguage} /> */}
					<div className="logo">jardulik</div>
					<p>Вход в панель модерации</p>
				</div>
				<form className="login-form" onSubmit={handleSubmit}>
					<div className={`form-group ${isUsernameEmpty ? "reqLabel" : ""}`}>
						<label
							htmlFor="username"
							className={`${isUsernameEmpty ? "reqLabel" : ""}`}
						>
							Логин{isUsernameEmpty ? " *" : ""}
						</label>
						<input
							type="text"
							id="username"
							name="username"
							autoComplete="username"
							value={formData.username}
							placeholder="Логин"
							onChange={handleInputChange}
							onFocus={() => setIsUsernameEmpty(false)}
							className={isUsernameEmpty ? "reqInput" : ""}
						/>
					</div>
					<div className={`form-group ${isPasswordEmpty ? "reqLabel" : ""}`}>
						<label
							htmlFor="password"
							className={`${isPasswordEmpty ? "reqLabel" : ""}`}
						>
							Пароль{isPasswordEmpty ? " *" : ""}
						</label>
						<div className="password-field">
							<input
								type={showPassword ? "text" : "password"}
								id="password"
								name="password"
								autoComplete="current-password"
								value={formData.password}
								placeholder="Пароль"
								onChange={handleInputChange}
								onFocus={() => setIsPasswordEmpty(false)}
								className={isPasswordEmpty ? "reqInput" : ""}
							/>
							<button
								type="button"
								className="password-toggle"
								onClick={() => setShowPassword((v) => !v)}
								aria-label={
									showPassword ? "Скрыть пароль" : "Показать пароль"
								}
								tabIndex={-1}
							>
								<EyeIcon visible={showPassword} />
							</button>
						</div>
					</div>
					{/* <div className="form-group center">
                        <label htmlFor="captcha">{t('enterTheAnswer')}</label>
                        <div className='captcha'>
                            <label htmlFor="captcha">{captcha.question}</label>
                            <input
                                type="text"
                                id="captcha"
                                name="captcha"
                                autoComplete="off"
                                value={formData.captcha}
                                placeholder="XX"
                                onChange={handleNumericInputChange} // Use numeric input handler
                                maxLength={2}
                                className={isCaptchaIncorrect ? 'reqInput' : ''}
                            />
                        </div>
                        {isCaptchaIncorrect && <span className='reqLabel'>{t('incorrectAnswer')}</span>}
                    </div> */}
					{errorMessage && <div className="error-message">{errorMessage}</div>}
					<button type="submit">Войти</button>
				</form>
			</div>
		</div>
	);
};

export default Login;
